export default __webpack_public_path__ + "static/media/14.1e98178d.gif";